import { IPricingRevaluationItemResultDTO } from "../../coreapi-dto/dirs/pricingInvoice";
import { IPricingAdpricePercentResponse, IPricingRevaluationItemDTO } from "../../coreapi-dto/dirs/pricingRevaluation";
import { ContentType } from "../../fetchApiDistributor/contentTypes";
import BaseCoreApiRequest from "../baseCoreApiRequest";
import { CoreApiResponse, IRequestEventHandler } from "../common";

class PricingRevaluationRequest extends BaseCoreApiRequest {
    private _routePrefix: string = "pricing";
    private _token: string;
    private _eventHandler: IRequestEventHandler;

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl);
        this._token = token;
        this._eventHandler = eventHandler;
    }

    sendCalculateItemRequest(idGlobal: string, body: IPricingRevaluationItemDTO, callback?: (e: CoreApiResponse<IPricingRevaluationItemResultDTO>) => void, signal?: AbortSignal | null) {
        super.post<IPricingRevaluationItemResultDTO>(
            `${this._baseUrl}/${this._routePrefix}/${idGlobal}/RevaluationItem`,
            body,
            this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),
            (e: CoreApiResponse<IPricingRevaluationItemResultDTO>) => {
                callback?.(e);
            },
            signal
        );
    }

    sendCalculateAdpricePercentRequest(idGlobal: string, body: IPricingRevaluationItemDTO, callback?: (e: CoreApiResponse<IPricingAdpricePercentResponse>) => void, signal?: AbortSignal | null) {
        super.post<IPricingAdpricePercentResponse>(
            `${this._baseUrl}/${this._routePrefix}/${idGlobal}/RevaluationItem/CalculateAdpricePercent`,
            body,
            this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),
            (e: CoreApiResponse<IPricingAdpricePercentResponse>) => {
                callback?.(e);
            },
            signal
        );
    }

    sendCalculateBatchRequest(idGlobal: string, body: IPricingRevaluationItemDTO[], callback?: (e: CoreApiResponse<IPricingRevaluationItemResultDTO[]>) => void, signal?: AbortSignal | null) {
        super.post<IPricingRevaluationItemResultDTO[]>(
            `${this._baseUrl}/${this._routePrefix}/${idGlobal}/RevaluationItemsBatch`,
            body,
            this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),
            (e: CoreApiResponse<IPricingRevaluationItemResultDTO[]>) => {
                callback?.(e);
            },
            signal
        );
    }
}

export default PricingRevaluationRequest;
